export default __webpack_public_path__ + "static/media/register-slide-3.67220814.jpg";